import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  contactDetailsTitle: {
    defaultMessage: '4. Confirm Contact Details',
    description: 'Title for the contact details section',
    id: 'dXNZxo',
  },
  contactDetailsDescription: {
    defaultMessage: 'Confirm your contact details',
    description: 'Description for contact details section',
    id: 'ArHQ2C',
  },
  firstName: {
    defaultMessage: 'First name',
    description: 'First name label',
    id: 'K/so5e',
  },
  lastName: {
    defaultMessage: 'Last name',
    description: 'Last name label',
    id: '+h0BjN',
  },
  shipstationEmail: {
    defaultMessage: 'ShipStation Email',
    description: 'ShipStation email label',
    id: 'wouBvU',
  },
  alternateEmail: {
    defaultMessage: 'Alternate Email',
    description: 'Alternate email label',
    id: '+9mXil',
  },
  optional: {
    defaultMessage: '(Optional)',
    description: 'Indicates that a form field is optional',
    id: 'P1NZer',
  },
  company: {
    defaultMessage: 'Company',
    description: 'Company label',
    id: 'jI/8DZ',
  },
  phone: {
    defaultMessage: 'Phone',
    description: 'Phone label',
    id: 'quRCCv',
  },
  additionalInfo: {
    defaultMessage: "Is there any additional information about your business or fulfillment needs that you'd like to share?",
    description: 'Additional information textarea label',
    id: 'wHT2x+',
  },
});
